define('plugin/facebook/FacebookPlugin',['require','lib/plugin/PluginAbstract','underscore','plugin/facebook/view/FacebookView','Config'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
    var FacebookView = require('plugin/facebook/view/FacebookView');
    var Config = require('Config');

    return PluginAbstract.extend({

        _fbUrl: '//connect.facebook.net/en_US/sdk.js',
        _detailsStep: null,
        _detailsStepView: null,
        _facebookRegions: {
            'facebookContainer': '#sb_fb_container'
        },
        _view: null,

        /**
         * Initializes plugin
         */
        initialize: function () {
            this.loadFb();
        },

        loadFb: function () {
            window.fbAsyncInit = _.bind(this.loadFbAsync, this);

            jQuery.getScript(this._fbUrl);
        },

        loadFbAsync: function () {
            FB.init({
                appId: Config.getInstance().getOption('fb_app_id'),
                cookie: true,
                xfbml: true,
                version: 'v2.5'
            });
            FB.getLoginStatus(_.bind(this.setLoginStatus, this));
        },

        setLoginStatus: function (resp) {
            if (resp.status === 'connected') {
                this.loadUserDetails();
            }
        },

        loadUserDetails: function () {
            FB.api('/me', _.bind(this.setUserDetails, this));
        },

        setUserDetails: function (resp) {
            var model = this._stepManager.getBookingModel();
            model.set({
                'fb_name': resp.name,
                'fb_id': resp.id,
                'fb_token': FB.getAccessToken(),
                'client_name': resp.name,
                'client_email': resp.email ? resp.email : model.get('client_email')
            });
            if (this._detailsStepView) {
                this._detailsStepView.render();
            }
        },

        performLogin: function () {
            FB.login(_.bind(this.loadUserDetails, this), {'scope': 'email,public_profile'});
        },

        performLogout: function () {
            FB.logout();

            this._stepManager.getBookingModel().set({
                'fb_name': null,
                'fb_id': null,
                'fb_token': null
            });
            if (this._detailsStepView) {
                this._detailsStepView.render();
            }
        },

        /**
         * Subscribe to event to show facebook login view
         */
        initStepManagerEvents: function () {
            this.listenTo(this._stepManager, 'step:render:details', this.addUserLicenseView);
        },

        /**
         * Before show details step view we add facebook regions and views
         *
         * @param DetailsStep step
         * @param DetailsView view
         * @param Marionette.Region region
         */
        addUserLicenseView: function (step, view, region) {
            this._detailsStep = step;
            this._detailsStepView = view;
            _.each(this._facebookRegions, function (selector, fbRegion) {
                view.addRegion(fbRegion, selector);
            });

            this.updateFacebookViewsState();
        },

        /**
         * Updates facebook plugin views
         */
        updateFacebookViewsState: function () {
            this._view = new FacebookView({
                model: this._stepManager.getBookingModel()
            });
            this._detailsStepView.facebookContainer.show(this._view);

            this.listenTo(this._view, 'login', this.performLogin);
            this.listenTo(this._view, 'logout', this.performLogout);
        }

    });

});
